import LandingClasses from "../Mobile/landingMobile/LandingMobile.module.css"
import DepartmentsClasses from "../Mobile/DepartmentsMobile/DepartmentsMobile.module.css"
import OurWorkClasses from "../Mobile/About/About.module.css"
import MapClasses from "../Mobile/MapMobile/MapMobile.module.css"
import FactsNFiguresClasses from "../Mobile/FactsNFiguresMobile/FactsNFiguresMobile.module.css"
import FooterClasses from "../Mobile/FooterMobile/FooterMobile.module.css"
import GivingClasses from "../Mobile/MapMobile/Giving/Giving.module.css"

//This folder Gathers container classes from various components for Mobile and exports them together
// It helps in the functionality of scrolling to the component


const ContainerClasses = {
    LandingContainer: LandingClasses.container,
    DepartmentsContainer: DepartmentsClasses.container,
    OurWorkContainer: OurWorkClasses.container,
    MapContainer: MapClasses.container,
    FactsNFIguresContainer: FactsNFiguresClasses.bigNumber,
    FooterContainer: FooterClasses.container,
    GivingContainer: GivingClasses.container,
}
export default ContainerClasses;